<div class="modal-container" [class.disabled-milestone-timeline]="activeMilestone == false">
  <div class="modal-header px-0 pb-2 pb-md-3 d-flex flex-column flex-md-row align-items-center">
    <div class="d-flex align-items-center w-100 header-title">
      <div class="flag-wrapper d-inline-block me-2">
        <mtm-status-flag-milestone
          [isTransparentBg]="true"
          [status]="statusValue || ProjectStatus.IN_PROGRESS"
          [flagWidth]="30"
          [flagHeight]="30"></mtm-status-flag-milestone>
      </div>
      <h4 class="modal-title text-uppercase">{{ milestone?.name }}</h4>
      @if (milestone?.name) {
        <div class="d-flex align-items-center ms-2 tooltip-dropdown pointer" ngbDropdown placement="bottom">
          <i class="mtm-icon mtm-icon-info-grey p-0" ngbDropdownToggle></i>
          <div ngbDropdownMenu class="tooltip-dropdown-menu">
            <span class="arrow"></span>
            <div class="d-flex flex-column">
              <div class="mb-1 _bold text-capitalize">{{ 'milestoneStatusEditor_explanation' | translate }}</div>
              <div>{{ descriptionKey | translate }}</div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="d-flex align-items-center ms-md-auto active-milestone-field mt-3 mt-md-0 active-milestone-control">
      <label class="text-nowrap my-0 me-3 _600" for="activeMilestoneField">{{ milestoneLabel | translate }}</label>
      <div class="d-flex align-items-center ms-auto ms-md-none">
        <ui-switch
          class="d-flex align-items-center"
          defaultBgColor="black"
          size="small"
          switchColor="#efefef"
          [(ngModel)]="activeMilestone"
          id="activeMilestoneField"></ui-switch>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="milestoneForm" (ngSubmit)="save()">
      <div class="input-field d-flex flex-column align-items-center">
        <div class="d-flex flex-column flex-md-row align-items-center input-row">
          <div class="d-flex flex-column align-items-start field-container drive-date-field">
            <label for="driveDateField">{{ 'milestoneStatusEditor_dueDate' | translate }}</label>
            <div
              class="input-group position-relative date-field"
              [class.has-error]="milestoneForm.controls?.driveDate?.errors"
              [class.empty-date]="!milestoneForm.controls?.driveDate?.value">
              <input
                id="driveDateField"
                class="form-control date-picker"
                formControlName="driveDate"
                ngbDatepicker
                [readOnly]="true"
                #driveDate="ngbDatepicker"
                placeholder="{{ 'milestoneStatusEditor_dueDate' | translate }}"
                firstDayOfWeek="1" />
              @if (milestoneForm.controls?.driveDate?.value) {
                <span class="date-label">{{ milestoneForm.controls.driveDate.value | ngbDate }}</span>
              }
              <img src="/assets/img/dashboard/date-edit.svg" height="11" width="12" priority alt="Edit Date" />
            </div>
          </div>
          <div class="field-container status-field">
            <div class="d-flex align-items-center mb-2 tooltip-dropdown pointer" ngbDropdown placement="bottom">
              <i class="mtm-icon mtm-icon-info-grey me-2 p-0" ngbDropdownToggle></i>
              <label class="m-0" for="statusField">{{ 'status' | translate }}</label>
              <div id="statusField" ngbDropdownMenu class="tooltip-dropdown-menu">
                <span class="arrow"></span>
                <div class="mb-1 _600">{{ 'Status' | translate }}</div>
                <div class="status-info">
                  <div class="d-flex align-items-start mb-2">
                    <mtm-status-flag-milestone
                      [style.margin-top]="'2px'"
                      [isTransparentBg]="true"
                      class="me-2 flag-wrapper"
                      [status]="ProjectStatus.IN_PROGRESS"
                      [flagWidth]="18"
                      [flagHeight]="18"></mtm-status-flag-milestone>
                    <span class="m-0">{{ 'milestone_inprogress' | translate }}</span>
                  </div>
                  <div class="d-flex align-items-start mb-2">
                    <mtm-status-flag-milestone
                      [style.margin-top]="'2px'"
                      class="me-2"
                      [status]="ProjectStatus.COMPLETED"
                      [flagWidth]="18"
                      [flagHeight]="18"></mtm-status-flag-milestone>
                    <span class="m-0">{{ 'milestone_completed' | translate }}</span>
                  </div>
                  <div class="d-flex align-items-start mb-2">
                    <mtm-status-flag-milestone
                      [style.margin-top]="'2px'"
                      class="me-2"
                      [status]="ProjectStatus.UPCOMING_EXPIRY"
                      [flagWidth]="18"
                      [flagHeight]="18"></mtm-status-flag-milestone>
                    <span class="m-0">{{ 'milestone_upcoming_expiry' | translate }}</span>
                  </div>
                  <div class="d-flex align-items-start mb-2">
                    <mtm-status-flag-milestone
                      [style.margin-top]="'2px'"
                      class="me-2"
                      [status]="ProjectStatus.DELAYED"
                      [flagWidth]="18"
                      [flagHeight]="18"></mtm-status-flag-milestone>
                    <span class="m-0">{{ 'milestone_overdue' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex" ngbDropdown placement="bottom">
              <div
                class="d-flex align-items-center justify-content-center selected-status px-2"
                ngbDropdownToggle
                [style.cursor]="'default'"
                [class.status-in-progress]="statusValue === ProjectStatus.IN_PROGRESS"
                [class.status-delayed]="statusValue === ProjectStatus.DELAYED"
                [class.status-upcoming-expiry]="statusValue === ProjectStatus.UPCOMING_EXPIRY"
                [class.status-completed]="statusValue === ProjectStatus.COMPLETED">
                <mtm-status-flag-milestone
                  [isTransparentBg]="true"
                  [status]="statusValue || ProjectStatus.IN_PROGRESS"
                  [flagWidth]="24"
                  [flagHeight]="24"></mtm-status-flag-milestone>
                <span class="status-label mx-2">{{ `sectionStatus_${statusValue}` | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row align-items-center input-row">
          @if (hasNegotiatedDate) {
            <div class="d-flex flex-column align-items-start field-container">
              <div class="d-flex align-items-center mb-2 tooltip-dropdown pointer" ngbDropdown placement="bottom">
                <i class="mtm-icon mtm-icon-info-grey me-2 p-0" ngbDropdownToggle></i>
                <label class="m-0" for="negotiatedDateField">{{
                  'milestoneStatusEditor_negotiatedDate' | translate
                }}</label>
                <div ngbDropdownMenu class="tooltip-dropdown-menu">
                  <span class="arrow"></span>
                  <div class="mb-1 _600">{{ 'Rules' | translate }}</div>
                  <div class="status-info">
                    {{ 'milestone_rules_info' | translate }}
                  </div>
                </div>
              </div>
              <div class="col p-0">
                <div
                  class="input-group"
                  style="height: 35px; width: 300px"
                  [class.has-error]="milestoneForm.controls?.negotiatedDate?.errors"
                  [class.empty-date]="!milestoneForm.controls?.negotiatedDate?.value">
                  <input
                    id="negotiatedDateField"
                    class="form-control h-100 date-picker"
                    formControlName="negotiatedDate"
                    ngbDatepicker
                    placeholder="{{ 'milestoneStatusEditor_negotiatedDate' | translate }}"
                    #negotiatedDate="ngbDatepicker"
                    [maxDate]="negotiatedMaxDate"
                    [minDate]="minNegotiatedDate"
                    firstDayOfWeek="1"
                    (click)="negotiatedDate.toggle()" />
                  <div
                    class="input-group-addon d-flex flex-column justify-content-center"
                    (click)="negotiatedDate.toggle()"
                    [mtmDatePickerDirective]="negotiatedDate"
                    (keydown.enter)="negotiatedDate.toggle()">
                    <img src="/assets/img/dashboard/date-edit.svg" height="11" width="12" alt="Date Picker" />
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="col p-0">
            <label for="actualDateField">{{ 'milestoneStatusEditor_actualDate' | translate }}</label>
            <div
              class="input-group"
              style="height: 35px; width: 300px"
              [class.has-error]="milestoneForm.controls?.actualDate?.errors"
              [class.empty-date]="!milestoneForm.controls?.actualDate?.value">
              <input
                id="actualDateField"
                class="form-control h-100 date-picker"
                formControlName="actualDate"
                ngbDatepicker
                [minDate]="minActualDate"
                [maxDate]="actualMaxDate"
                placeholder="{{ 'milestoneStatusEditor_actualDate' | translate }}"
                #actualDate="ngbDatepicker"
                firstDayOfWeek="1"
                (click)="actualDate.toggle()" />
              <div
                class="input-group-addon d-flex flex-column justify-content-center"
                (click)="actualDate.toggle()"
                (keydown.enter)="actualDate.toggle()"
                [mtmDatePickerDirective]="actualDate">
                <img src="/assets/img/square-calendar.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="milestone-comment-container p-3">
        <mtm-milestone-comment [milestoneId]="milestone.id" [isMilestone]="true"></mtm-milestone-comment>
      </div>
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-center mt-2 mb-1 buttons">
        <button
          type="button"
          class="btn btn-large text-uppercase cancel-btn"
          (click)="cancel()"
          [disabled]="isLoading"
          >{{ 'cancel' | translate }}</button
        >
        <button type="submit" class="btn btn-large text-uppercase apply-btn" [disabled]="isLoading">{{
          'apply' | translate
        }}</button>
      </div>
    </form>
  </div>
</div>
